import React, { useEffect, useState } from 'react';
import { Car } from 'lucide-react';
import type { AutomobileBrand } from '../../types/automobile';
import { AUTOMOBILE_LOGO_BOX_CLASS } from '../../types/automobile';
import AutomobileBrandLogoImage from './AutomobileBrandLogoImage';

interface Props {
  brand: Pick<AutomobileBrand, 'logoUrl' | 'logoFocalX' | 'logoFocalY' | 'logoZoom'>;
  darkMode: boolean;
  className?: string;
  iconSize?: number;
}

const AutomobileBrandLogo: React.FC<Props> = ({
  brand,
  darkMode,
  className = AUTOMOBILE_LOGO_BOX_CLASS,
  iconSize = 24,
}) => {
  const [failed, setFailed] = useState(false);
  const zoomedOut = (brand.logoZoom ?? 100) < 100;

  useEffect(() => {
    setFailed(false);
  }, [brand.logoUrl, brand.logoFocalX, brand.logoFocalY, brand.logoZoom]);

  if (failed || !brand.logoUrl) {
    return (
      <div
        className={`${className} rounded-md flex items-center justify-center shrink-0 ${
          darkMode ? 'bg-gray-800/40' : 'bg-gray-100/80'
        }`}
      >
        <Car size={iconSize} className="text-indigo-500" aria-hidden />
      </div>
    );
  }

  return (
    <div
      className={`${className} flex items-center justify-center shrink-0 overflow-hidden ${
        zoomedOut ? 'bg-transparent' : 'bg-transparent'
      }`}
      aria-hidden
    >
      <AutomobileBrandLogoImage
        src={brand.logoUrl}
        frame={{
          focalX: brand.logoFocalX,
          focalY: brand.logoFocalY,
          zoom: brand.logoZoom,
        }}
        onError={() => setFailed(true)}
      />
    </div>
  );
};

export default AutomobileBrandLogo;
